import styled, { css } from 'styled-components';
import { sizes } from 'style';
import { A } from 'components/Typography';
import { StyledButton } from '../../styled';

export const StyledDownloadButton = styled(StyledButton)`
  white-space: nowrap;

  ${({ disabled }) =>
    disabled &&
    css`
      display: none;

      @media ${sizes.tabletPortrait} {
        display: flex;
      }
    `};
`;

export const StyledLink = styled(A)`
  underline: none;
  text-decoration: none;
`;

export const StyledImg = styled.img`
  margin-right: 0.2rem;
`;
